import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityFormMode } from '@/common/entityFramework/enumerations/EntityFormMode';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';
import { EntityPropCode } from './formFields/EntityPropCode';
import { EntityPropIdField } from './formFields/EntityPropIdField';
import { EntityPropOwnerField } from './formFields/EntityPropOwnerField';
import { EntityPropValue } from './formFields/EntityPropValue';

// ownerObj (the entity a property belongs to, e.g. a Program) may be supplied by an embedding parent (e.g. a
// Program's Properties dialog); otherwise it's resolved from the route-level EntityProp being viewed, via its own
// entity/entityId fields.
// propIdFilter is an additional Expr ANDed onto the Prop picker (e.g. to narrow by Program type).
// ownerOptions (optional): [{ label, entity, entityId, ownerObj }] lets the user pick which of several owners
// (e.g. a Program Product or one of its Tiers) this Property applies to, instead of a single fixed owner.
export const EntityPropForm = ({ ownerObj: ownerObjProp, propIdFilter, ownerOptions, ...formProps }) => {
  const { entityObj } = useEntityMgr();
  const rsrc = useRsrc();
  const [propObj, setPropObj] = useState(ownerObjProp ?? null);

  useEffect(() => {
    if (ownerObjProp) {
      setPropObj(ownerObjProp);
      return;
    }
    const entity = entityObj?.entity;
    const entityId = entityObj?.entityId;

    if (!entity || !entityId) return;

    rsrc.byId('md', entity, entityId).then((res) => {
      setPropObj(res);
    });
  }, [ownerObjProp, entityObj, rsrc]);

  if (!propObj) return <></>;

  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.code.component = <EntityPropCode propObj={propObj} ownerOptions={ownerOptions} />;
    fieldToFieldDef.propId.component = (
      <EntityPropIdField fieldDef={fieldToFieldDef.propId} propIdFilter={propIdFilter} />
    );
    fieldToFieldDef.value.component = <EntityPropValue fieldDef={fieldToFieldDef.value} />;

    if (ownerOptions) {
      // The picker below manages entity/entityId together; the raw entity field would otherwise be redundant
      delete fieldToFieldDef.entity;
      fieldToFieldDef.entityId.component = (
        <EntityPropOwnerField ownerOptions={ownerOptions} readOnly={formProps.mode !== EntityFormMode.ADD} />
      );
    }

    return fieldToFieldDef;
  };

  return <EntityForm entity="ENTITY_PROP" augFieldDefs={augFieldDefs} {...formProps} />;
};
